import { useFetch } from '../../../hooks/useFetch';
import {
  errorNotification,
  successNotification,
} from '../../../providers/mantine-notifications';
import {
  EnrichedSectorLog,
  SectorDailyLogDto,
  UpsertSectorDailyLogData,
  findEmployeeSectorRequest,
  getEnrichedSectorLogsRequest,
  getSectorDailyLogRequest,
  listSectorDailyLogsByDateRequest,
  upsertSectorDailyLogRequest,
} from '../../sector-daily-logs';

export function useUpsertSectorDailyLog() {
  const {
    fetchData,
    state: { loading },
  } = useFetch<SectorDailyLogDto>();

  const upsert = (data: UpsertSectorDailyLogData, onSuccess?: () => void) =>
    fetchData({
      fetcher: () => upsertSectorDailyLogRequest(data),
      onError: () =>
        errorNotification({
          title: 'Erro ao salvar registro.',
          message: 'Tente novamente.',
        }),
      onSuccess: () => {
        successNotification({ title: 'Registro salvo!', message: '' });
        onSuccess?.();
      },
    });

  return { upsert, loading };
}

export function useListSectorDailyLogs() {
  const {
    fetchData,
    state: { data: logs, loading },
  } = useFetch<SectorDailyLogDto[]>();

  const fetch = (date: string) =>
    fetchData({
      fetcher: () => listSectorDailyLogsByDateRequest(date),
      onError: () =>
        errorNotification({
          title: 'Erro ao buscar registros.',
          message: 'Tente novamente.',
        }),
    });

  return { fetch, logs, loading };
}

export function useGetSectorDailyLog() {
  const {
    fetchData,
    state: { data: log, loading },
  } = useFetch<SectorDailyLogDto | null>();

  const fetch = (date: string, sector: string) =>
    fetchData({
      fetcher: () => getSectorDailyLogRequest(date, sector),
      onError: () =>
        errorNotification({
          title: 'Erro ao buscar registro do setor.',
          message: 'Tente novamente.',
        }),
    });

  return { fetch, log, loading };
}

export function useGetEnrichedSectorLogs() {
  const {
    fetchData,
    state: { data: logs, loading },
  } = useFetch<EnrichedSectorLog[]>();

  const fetch = (date: string, sector?: string) =>
    fetchData({
      fetcher: () => getEnrichedSectorLogsRequest(date, sector),
      onError: () =>
        errorNotification({
          title: 'Erro ao buscar registros.',
          message: 'Tente novamente.',
        }),
    });

  return { fetch, logs, loading };
}

export function useFindEmployeeSector() {
  const {
    fetchData,
    state: { data: results, loading },
  } = useFetch<SectorDailyLogDto[]>();

  const find = (code: string, date: string) =>
    fetchData({
      fetcher: () => findEmployeeSectorRequest(code, date),
      onError: () =>
        errorNotification({
          title: 'Erro ao consultar funcionário.',
          message: 'Tente novamente.',
        }),
    });

  return { find, results, loading };
}
